import { Component } from '@angular/core';

import { NceService } from '../services/nce.service';

import { StorageService } from '../../shared/services/storage.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { ErrorService } from '../../shared/services/error.service';

@Component({
    selector: 'nce-fill-in-particulars-ext',
    templateUrl: 'fill-in-particulars-ext.component.html'
})
export class NceFillInParticularsExtComponent{

    vTempNCEID: string;
    vTempPlantMapID: string;
    vTempPlantMapPIN: string;    

    vMinContractDate = new Date();

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _errorService: ErrorService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('nce-fill-in-particulars');
        
        this._nceService.resetNCEData();
        this._nceService.resetFillInParticulars();
        this._nceService.resetError();
        
        this._storageService.setSessionItem('extensionNCE', '1');
        this.vTempNCEID = this.getFillInParticulars().nce_request_id;

        this.vMinContractDate = new Date(this.getFillInParticulars().contract_start);
        this.vMinContractDate.setDate(this.vMinContractDate.getDate() + 1);
    }

    getFillInParticulars(){
        return this._nceService.getFillInParticulars();
    }
    
    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    isDisableSubmit(){
        return this._nceService.isDisableSaveFillInParticular();
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    checkNCEID(){
        if(this.vTempNCEID === '' || this.vTempNCEID === undefined ||
            this.vTempPlantMapID === '' || this.vTempPlantMapID === undefined){
            return;
        }
        this.vTempNCEID = this.vTempNCEID.toUpperCase().trim();
        this._nceService.checkNCERequestID(this.vTempNCEID, this.vTempPlantMapID, this.vTempPlantMapPIN);
    }

    submitFillInParticulars(){
        this._nceService.saveFillInParticulars();
    }

    goBack(){
        let vLink = ['home'];
        this._pageNavigationService.navigate(vLink);
    }

    isInputShow() {
        if(this.getFillInParticulars().nce_record_id !== ''){
            this.vMinContractDate = new Date(this.getFillInParticulars().contract_start);
            this.vMinContractDate.setDate(this.vMinContractDate.getDate() + 1);
        }
        return this.getFillInParticulars().nce_record_id !== '';
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/fill-in-particulars-ext.component.ts